import { AnyAction } from 'redux';

const SET_SELECTED_STUDY_ID = 'SET_SELECTED_STUDY_ID';

const initialState = {
  selectedStudyId: ''
};

export async function setSelectedStudyId(dispatch: any, study: string) {
  dispatch({
    type: SET_SELECTED_STUDY_ID,
    data: study
  });
}

const selectedStudyIdReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_SELECTED_STUDY_ID: {
      return {
        ...state,
        selectedStudyId: action.data
      };
    }
    default:
      return state;
  }
};

export default selectedStudyIdReducer;
